import apiFetch from '../apiFetch'

export default function (campaignId, campaign, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/campaign/${campaignId}`, method: 'PUT', body: campaign, token: token, lastAccessDate })
}
